import styled from 'styled-components';
import { isChrome } from '../../utils/platforms.js';
import { typography } from '../../typography/typography.js';

var getButtonBackgroundColor = function getButtonBackgroundColor(selected, disabled, theme) {
  if (selected) {
    if (disabled) {
      return theme.colorPalette.neutralColors.light.shade_default;
    }

    return theme.colorPalette.neutralColors.dark.shade_light_1;
  }

  return theme.colorPalette.neutralColors.light.shade_white;
};

var getButtonFontColor = function getButtonFontColor(selected, disabled, theme) {
  if (selected && !disabled) {
    return theme.colorPalette.neutralColors.light.shade_white;
  }

  return theme.colorPalette.neutralColors.dark.shade_light_1;
};

var getButtonBorderColor = function getButtonBorderColor(selected, disabled, showErrorOutline, theme) {
  if (showErrorOutline) {
    return theme.colorPalette.utilityColors.error;
  }

  if (selected) {
    if (disabled) {
      return theme.colorPalette.neutralColors.dark.shade_light_4;
    }

    return theme.colorPalette.neutralColors.dark.shade_light_1;
  }

  return theme.colorPalette.neutralColors.dark.shade_light_1;
};

var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1xfmido-0"
})(["width:100%;height:100%;display:flex;flex-direction:column;", ""], function (_ref) {
  var rootStyle = _ref.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var Fieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "styledComponents__Fieldset",
  componentId: "sc-1xfmido-1"
})(["padding:0;border:none;width:100%;margin:0;"]);
process.env.NODE_ENV !== "production" ? Fieldset.displayName = 'Fieldset' : void 0;
var TooltipContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__TooltipContainer",
  componentId: "sc-1xfmido-2"
})(["padding-left:6px;"]);
process.env.NODE_ENV !== "production" ? TooltipContainer.displayName = 'TooltipContainer' : void 0;
var StackedWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__StackedWrapper",
  componentId: "sc-1xfmido-3"
})(["@media screen and (max-width:", "){display:flex;flex-direction:column;margin-top:0;width:100%;position:relative;z-index:0;}"], function (_ref2) {
  var verticalStackingBreakPoint = _ref2.verticalStackingBreakPoint;
  return verticalStackingBreakPoint <= 576 ? "".concat(verticalStackingBreakPoint, "px") : '320px';
});
process.env.NODE_ENV !== "production" ? StackedWrapper.displayName = 'StackedWrapper' : void 0;
var ButtonSelectorWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ButtonSelectorWrapper",
  componentId: "sc-1xfmido-4"
})(["display:flex;margin-top:0;position:relative;z-index:0;clear:left;"]);
process.env.NODE_ENV !== "production" ? ButtonSelectorWrapper.displayName = 'ButtonSelectorWrapper' : void 0;
var Button = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__Button",
  componentId: "sc-1xfmido-5"
})(["position:relative;display:flex;justify-content:center;align-items:center;font-size:", ";font-weight:", ";text-align:center;min-width:75px;margin:0;padding:12px 24px;height:100%;cursor:", ";font-family:", ";vertical-align:middle;color:", ";background-color:", ";border:2px solid ", ";", " width:100%;z-index:2;&:focus{z-index:3;}&:hover{", " cursor:", ";}"], typography.fontSize, function (_ref3) {
  var selected = _ref3.selected;
  return selected ? 'bold' : '600';
}, function (props) {
  return props.disabled ? 'const' : 'pointer';
}, typography.fontFamily, function (_ref4) {
  var selected = _ref4.selected,
      disabled = _ref4.disabled,
      theme = _ref4.theme;
  return getButtonFontColor(selected, disabled, theme);
}, function (_ref5) {
  var selected = _ref5.selected,
      disabled = _ref5.disabled,
      theme = _ref5.theme;
  return getButtonBackgroundColor(selected, disabled, theme);
}, function (_ref6) {
  var selected = _ref6.selected,
      disabled = _ref6.disabled,
      showErrorOutline = _ref6.showErrorOutline,
      theme = _ref6.theme;
  return getButtonBorderColor(selected, disabled, showErrorOutline, theme);
}, function (_ref7) {
  var isLastButton = _ref7.isLastButton,
      isVerticallyStacked = _ref7.isVerticallyStacked;

  if (!isLastButton) {
    var border = isVerticallyStacked ? 'border-bottom: none;' : 'border-right: none;';
    return isChrome() ? "outline-offset: 1px;\n        ".concat(border) : border;
  }

  return isChrome() ? 'outline-offset: 2px;' : '';
}, function (_ref8) {
  var disabled = _ref8.disabled,
      selected = _ref8.selected,
      theme = _ref8.theme;

  if (!selected && !disabled) {
    return "background-color: ".concat(theme.colorPalette.neutralColors.light.shade_default, ";");
  }

  return '';
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
process.env.NODE_ENV !== "production" ? Button.displayName = 'Button' : void 0;

export { Button, ButtonSelectorWrapper, Fieldset, Root, StackedWrapper, TooltipContainer };
